import { useForm } from 'react-hook-form';

import { CNMCFilesUploadForm } from '../types';

export function useCNMCFilesUploadFormState() {
  const initialValues: Partial<CNMCFilesUploadForm> = {
    textFiles: [],
    videoFiles: [],
    companyActivityFiles: [],
  };
  const form = useForm<CNMCFilesUploadForm>({
    mode: 'all',
    defaultValues: initialValues,
  });

  return { form, initialValues };
}
